import { APIClient } from '../../helpers/api_helper';

const api = new APIClient();

export interface FAQItem {
  question: string;
  answer: string;
}

// API expects this structure for FAQ
export interface APIFAQItem {
  title: string;
  description: string;
}

export interface BlogAddPayload {
  title: string;
  description: string;
  image: string;
  isActive: boolean;
  isFeatureBlog: boolean;
  blogCategory: string;
  publishedDate: string;
  sortNumber: number;
  isBannerBlog: boolean;
  isMustReadBlog: boolean;
  contents: Array<{
    title: string;
    description: string;
  }>;
  faq?: APIFAQItem[]; // API expects "faq" not "faqs", and uses title/description structure
  tag?: string; // Optional tag field
  html?: string; // Optional html field
  metaTitle?: string; // SEO meta title
  metaDescription?: string; // SEO meta description
}

export const addBlog = (data: BlogAddPayload) =>
  api.create('/api/v1/blogs/admin/add', data); 